<script setup>
import { ref, onMounted } from 'vue'
import gsap from "gsap";

import store from "@/store";

let prize   = ref({})

// Hooks: ---------------------------------------------------
onMounted(() => {

  prize.value = store.state.game_status?.prize?.data

  function animationPrize() {
    const video = document.querySelector("video")
    video.muted = true;
    video.play();
  }

  function animations() {
    let tl = gsap.timeline()
    tl.to(".h4", { y: 0, opacity: 1, duration: .5, delay: .5 })
    tl.to(".h3", { y: 0, opacity: 1, duration: .5 }, "<")
    tl.to(".desc", { y: 0, opacity: 1, duration: .5, delay: .5 })
    tl.to(".prize", { y: 0, opacity: 1, duration: .5, onComplete: () => animationPrize() },  "<")
    tl.to(".button", { y: 0, opacity: 1, duration: .5 }, "<")
  }

  animations();
  animationPrize();

})

</script>

<template>
  <main class="main">
    <section class="container">
      <div class="content">
        <h4 class="h4">ВАШ ПРИЗ</h4>
        <h3 class="h3" v-html="prize.title"/>
        <div class="desc" v-html="`<p>${prize.description}</p>`"/>
        <div class="prize">
          <video :src="require(`/src/assets/images/prize/animation.mp4`)" autoplay/>
        </div>
        <router-link class="button --back" :to="{ path: '/playing/' }">К РАБОЧЕМУ СТОЛУ</router-link>
      </div>
    </section>
  </main>
</template>

<style lang="scss" scoped>
.main {
  display: flex;
  align-items: center;
  height: auto;
  min-height: 100vh;
  overflow: hidden;
  background: #202020;
}

.content {
  display: grid;
  grid-template-columns: minmax(auto, 850px) minmax(560px, 625px);
  grid-template-rows: 35px auto auto 100px;
  justify-content: space-between;
  grid-gap: 40px 80px;
  height: 100%;
  padding: 45px 0;

  @media (max-width: 1440px) {
    grid-template-columns: 1.3fr minmax(430px, 0.7fr);
    grid-template-rows: 35px 65px;
    grid-gap: 30px;
    height: min-content;
  }
  @media (max-width: 1024px) {
    grid-template-columns: auto minmax(300px, auto);
  }
  @media (max-width: 768px) {
    grid-gap: 10px;
    grid-template-rows: auto;
    padding: 45px 0;
  }

  .h4 {
    grid-area: 1/1/2/2;
    text-transform: uppercase;
    margin-top: 40px;
    @media (max-width: 1280px) {
      grid-area: 1/1/2/3;
    }
    @media (max-width: 768px) {
      text-align: center;
    }
  }

  .h3 {
    grid-area: 2/1/3/2;
    margin-bottom: auto;
    text-transform: uppercase;
    z-index: 1;

    @media (max-width: 1280px) {
      grid-area: 2/1/3/3;
    }
    @media (max-width: 768px) {
      text-align: center;
    }
    @media screen and (orientation:landscape) and (max-width: 1024px) {
      grid-area: 2/1/3/2;
    }
  }

  .desc {
    grid-area: 3/1/5/2;
    display: flex;
    flex-direction: column;
    max-width: 800px;
    padding-top: 150px;
    @extend %font-inter-300;
    font-size: 34px;
    line-height: 1.17;

    a {
      text-decoration: underline;
      text-decoration-color: inherit;
      text-underline-offset: 0.2rem;
      text-decoration-thickness: 0.01rem;
    }

    @media (max-width: 1440px) {
      font-size: 26px;
    }
    @media (max-width: 1280px) {
      grid-area: 3/1/4/2;
      max-width: initial;
      justify-content: initial;
      padding-top: initial;
    }
    @media (max-width: 1024px) {
      font-size: 20px;
    }
    @media (max-width: 768px) {
      grid-area: 4/1/5/3;
      text-align: center;
      margin-bottom: 25px;
    }
    @media screen and (orientation:landscape) and (max-width: 1024px) {
      font-size: 12px;
    }

    p:not(:last-child) {
      margin-bottom: 25px;
    }
  }

  .prize {
    grid-area: 1/2/4/3;
    display: flex;
    justify-content: center;
    z-index: 0;

    @media (max-width: 1280px) {
      grid-area: 3/2/5/3;
      transform: translateY(-25px);
    }
    @media (max-width: 1024px) {
      max-width: 260px;
    }
    @media (max-width: 768px) {
      grid-area: 3/1/4/3;
      height: 100%;
      margin: 0 auto;
      transform: initial;
    }
    @media screen and (orientation:landscape) and (max-width: 1024px) {
      grid-area: 1/2/5/3;
    }

    video {
      width: 100%;
      height: 100%;
      object-fit: contain;
      object-position: center bottom;
      -webkit-mask-image: -webkit-radial-gradient(white, black);
      -webkit-backface-visibility: hidden;
      -moz-backface-visibility: hidden;
      -webkit-appearance: none;
    }
  }

  .button {
    grid-area: 4/2/5/3;

    @media (max-width: 1440px) {
      height: 70px;
      padding: 0 30px;
      font-size: 26px;
    }
    @media (max-width: 1280px) {
      grid-area: 4/1/5/2;
      max-width: max-content;
    }
    @media (max-width: 768px) {
      grid-area: 5/1/5/3;
      height: 50px;
      margin: 0 auto;
      font-size: 18px;
    }

    @media screen and (orientation:landscape) and (max-width: 1024px) {
      height: 50px;
      font-size: 18px;
    }
  }

}

.h4, .h3, .desc, .button {
  opacity: 0;
  transform: translateY(15%);
}
.prize {
  opacity: 0;
  transform: translateY(5%);
}
</style>
